export const BOOLEAN_FIELD_OPTION = {
    TRUE: true,
    FALSE: false
}

export const BOOLEAN_FIELD_OPTION_LABEL = {
    [BOOLEAN_FIELD_OPTION.TRUE]: "True",
    [BOOLEAN_FIELD_OPTION.FALSE]: "False"
}